/**
 * Data layer for `agency-plan-unlock-multi-client-sub-admins-white-label-smartlink-manual-campaign-grouping`. Thin typed fetch wrappers over /api/v1/agency-plan-unlock-multi-client-sub-admins-white-label-smartlink-manual-campaign-grouping.
 * Raw `fetch()` is confined to this file per the dash contract.
 */

export interface AgencyPlanUnlockMultiClientSubAdminsWhiteLabelSmartlinkManualCampaignGroupingRow {
	id: string;
	tenant_id: string;
	created_at: number;
	updated_at: number;
	[key: string]: unknown;
}

export interface ListAgencyPlanUnlockMultiClientSubAdminsWhiteLabelSmartlinkManualCampaignGroupingResponse {
	count: number;
	items: AgencyPlanUnlockMultiClientSubAdminsWhiteLabelSmartlinkManualCampaignGroupingRow[];
}

export interface CreateAgencyPlanUnlockMultiClientSubAdminsWhiteLabelSmartlinkManualCampaignGroupingBody {
	[key: string]: unknown;
}

const BASE = "/api/v1/agency-plan-unlock-multi-client-sub-admins-white-label-smartlink-manual-campaign-grouping";

async function parseOrThrow<T>(res: Response): Promise<T> {
	const text = await res.text();
	let data: unknown = null;
	if (text) {
		try {
			data = JSON.parse(text);
		} catch {
			data = text;
		}
	}
	if (!res.ok) {
		const msg =
			data &&
			typeof data === "object" &&
			data !== null &&
			"error" in data &&
			typeof (data as { error: unknown }).error === "string"
				? (data as { error: string }).error
				: `HTTP ${res.status}`;
		throw new Error(msg);
	}
	return data as T;
}

export async function list(): Promise<ListAgencyPlanUnlockMultiClientSubAdminsWhiteLabelSmartlinkManualCampaignGroupingResponse> {
	const res = await fetch(BASE, {
		method: "GET",
		credentials: "include",
		headers: { accept: "application/json" },
	});
	return parseOrThrow<ListAgencyPlanUnlockMultiClientSubAdminsWhiteLabelSmartlinkManualCampaignGroupingResponse>(res);
}

export async function create(body: CreateAgencyPlanUnlockMultiClientSubAdminsWhiteLabelSmartlinkManualCampaignGroupingBody): Promise<AgencyPlanUnlockMultiClientSubAdminsWhiteLabelSmartlinkManualCampaignGroupingRow> {
	const res = await fetch(BASE, {
		method: "POST",
		credentials: "include",
		headers: {
			accept: "application/json",
			"content-type": "application/json",
		},
		body: JSON.stringify(body ?? {}),
	});
	return parseOrThrow<AgencyPlanUnlockMultiClientSubAdminsWhiteLabelSmartlinkManualCampaignGroupingRow>(res);
}

export async function remove(id: string): Promise<{ removed: boolean }> {
	const res = await fetch(`${BASE}/${encodeURIComponent(id)}`, {
		method: "DELETE",
		credentials: "include",
		headers: { accept: "application/json" },
	});
	return parseOrThrow<{ removed: boolean }>(res);
}

export const agencyPlanUnlockMultiClientSubAdminsWhiteLabelSmartlinkManualCampaignGroupingQueryKeys = {
	all: ["agency-plan-unlock-multi-client-sub-admins-white-label-smartlink-manual-campaign-grouping"] as const,
	list: () => [...agencyPlanUnlockMultiClientSubAdminsWhiteLabelSmartlinkManualCampaignGroupingQueryKeys.all] as const,
	detail: (id: string) => [...agencyPlanUnlockMultiClientSubAdminsWhiteLabelSmartlinkManualCampaignGroupingQueryKeys.all, id] as const,
};
